import { envIsProduction, envName } from '../../lib/Environment.ts';

export const devEnvs = [
    'dev1',
    'dev2',
    'dev3',
    'dev4',
    'teb-1',
    'teb-2',
    'fvo-1',
    'fvo-2',
    'cfe-1',
    'cfe-2',
    'fab-1',
    'fab-2',
    'sip-1',
];

export function getDevEnvName(): string {
    return envIsProduction() ? '' : ` ${envName()}`;
}

export function getEnvChangeName(username: string | null): string | null {
    if (!username || !username.startsWith('goto-')) {
        return null;
    }
    return username.slice(5);
}
